import { Dispatch } from "redux";
import { FGetState } from "../app.reducer";
import appType from "./app.type";


const lastDataScanYearOld = (dataApp: any) => {
	return async (dispatch: Dispatch, getState: FGetState) => {
		dispatch({
			type: appType.APP.SCAN_YEAR_OLD,
			payload: dataApp
		});
	};
};

const clearState = () => {
	return async (dispatch: Dispatch, getState: FGetState) => {
		dispatch({
			type: appType.APP.CLEAR_STATE,
		});
	};
};

export default {
	lastDataScanYearOld,
	clearState
} as const;